import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { SliderType } from './sliderConfigAggregator';

type PageBuilderSliderProps = SliderType;

/**
 * Return the PB Slider
 * @param props
 * @constructor
 */
export function PageBuilderSlider(props: PageBuilderSliderProps) {
    const sliderRef = useRef<Slider>(null);

    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderSliderProps>(props);

    const layoutStyles = {
        minHeight: props.minHeight,
    };

    const sliderClassNames = ['pageBuilderSliderGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        sliderClassNames.push(...props.cssClasses);
    }

    /**
     * Gallery setting for slick slider
     */
    const settings: Settings = {
        accessibility: true,
        arrows: props.showArrows,
        autoplay: props.autoplay,
        autoplaySpeed: props.autoplaySpeed,
        dots: props.showDots,
        draggable: true,
        fade: props.fade,
        infinite: props.infinite,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 400,
        pauseOnHover: true,
    };

    /**
     * Render the Row Block UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={{
                ...advancedSettings,
                ...layoutStyles,
            }}
            classNames={sliderClassNames}
        >
            <Slider ref={sliderRef} {...settings}>
                {props.children}
            </Slider>
        </PageBuilderElementWrapper>
    );
}
